export default __webpack_public_path__ + "static/Fira-Code-SemiBold-df846bedbe1e413eeaf8609d5cea89f0.woff2";